import Vue from 'vue'
import VueIl8n from 'vue-i18n'
import enLocale from './en'
import zhLocale from './zh'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element英文包
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN' // 中文包

Vue.use(VueIl8n)

// 引入本地
const messages = {
  en: {
    message: 'hello',
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    message: '你好',
    ...zhLocale,
    ...elementZhLocale
  },
  zhHans: {
    ...require("./lang/zh-Hans.json"),
    ...elementZhLocale
  },
  zhHant: {
    ...require("./lang/zh-Hant.json"),
    ...elementZhLocale
  },
}

// 创建国际化实例
const il8n = new VueIl8n({
  locale: sessionStorage.getItem('locale') || 'zhHant',
  // 添加多个语言包
  messages
})

export default il8n
